import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import {
  Grow,
  MenuItem,
  MenuList,
  ListItemText,
  Paper,
} from "@material-ui/core"
import { toggleLocale } from "locale.js"
import classNames from "classnames"

const useStyles = makeStyles(theme => ({
  localeBox: {
    fontSize: "12px",
    padding: "0",
    "& .currentLocale": {
      backgroundColor: "#eeccd5",
    },
    "& .MuiTypography-body1": {
      fontSize: "12px",
      padding: "0 0 0 28px",
      [theme.breakpoints.down("sm")]: {
        padding: "0",
      },
    },
    "& .MuiListItem-button": {
      [theme.breakpoints.down("sm")]: {
        width: "68px",
        padding: "0",
        textAlign: "center",
      },
      minHeight: "auto",
      width: "130px",
      height: "36px",
    },
  },
  localeList: {
    minHeight: "auto",
    height: "36px",
    [theme.breakpoints.down("sm")]: {
      width: "68px",
      padding: "0",
      textAlign: "center",
    },
  },
  paper: {
    border: "1px solid #d3d4d5",
    borderRadius: "unset",
    boxShadow: "none",
  },
}))

const LanguageSwitchList = ({
  nowLocale,
  TransitionProps,
  handleLocaleClose,
}) => {
  const classes = useStyles()

  const handleListItemClick = index => event => {
    if (nowLocale !== index) {
      toggleLocale()
      handleLocaleClose()
      window.location.reload()
    }
  }

  return (
    <>
      <Grow
        {...TransitionProps}
        style={{
          transformOrigin: {
            vertical: "top",
            horizontal: "center",
          },
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "center",
          },
        }}
      >
        <Paper className={classes.paper}>
          <MenuList className={classes.localeBox}>
            <MenuItem
              id="selectLocaleJa"
              disabled={nowLocale === "ja"}
              selected={nowLocale === "ja"}
              onClick={handleListItemClick("ja")}
              data-ga="languageACJa"
              className={classNames(
                "localeList",
                nowLocale === "ja" ? "currentLocale" : ""
              )}
            >
              <ListItemText primary="日本語" />
            </MenuItem>
            <MenuItem
              id="selectLocaleEn"
              disabled={nowLocale === "en"}
              selected={nowLocale === "en"}
              onClick={handleListItemClick("en")}
              data-ga="languageACEn"
              className={classNames(
                "localeList",
                nowLocale === "en" ? "currentLocale" : ""
              )}
            >
              <ListItemText primary="English" />
            </MenuItem>
          </MenuList>
        </Paper>
      </Grow>
    </>
  )
}

export default LanguageSwitchList
